import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Typography, IconButton, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import clsx from "clsx";
import { useFileViewStyles } from "./styles";
export function FileView(props) {
    const { file, onRemove, onSelect, imgBackground, selected, children, className, ...rest } = props;
    const classes = useFileViewStyles();
    const onClickRemove = useCallback(e => {
        e.stopPropagation();
        if (onRemove && file)
            onRemove(file);
    }, [file, onRemove]);
    const onClick = useCallback(e => {
        e.stopPropagation();
        if (onSelect && file)
            onSelect(file);
    }, [file, onSelect]);
    const filename = decodeURI(file instanceof File ? file.name : file.substring(file.lastIndexOf("/") + 1));
    return (_jsx(Tooltip, { title: filename, children: _jsxs("div", { className: clsx(className, classes.root, {
                [classes.selected]: selected
            }), ...rest, children: [_jsx(Typography, { component: "span", onClick: onClick, className: clsx(classes.filename, {
                        [classes.selectable]: !!onSelect
                    }), children: filename }), onRemove && (_jsx(IconButton, { onClick: onClickRemove, className: classes.removeBtn, size: "small", children: _jsx(DeleteIcon, { "aria-label": "Delete" }) }))] }) }));
}
//# sourceMappingURL=FileView.js.map